import CalcEmptyListBlock from '../../../components/CalcEmptyListBlock/CalcEmptyListBlock';

const Templates = () => {
  console.log('Templates');
  return <CalcEmptyListBlock>The functionality in development.</CalcEmptyListBlock>;
};

export default Templates;
